import React, { createContext, useContext, useState, ReactNode } from 'react'

interface AdminSidebarContextType {
  isAdminSidebarOpen: boolean
  setIsAdminSidebarOpen: (isOpen: boolean) => void
}

const AdminSidebarContext = createContext<AdminSidebarContextType | undefined>(undefined)

export const AdminSidebarProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isAdminSidebarOpen, setIsAdminSidebarOpen] = useState(true)

  return (
    <AdminSidebarContext.Provider value={{ isAdminSidebarOpen, setIsAdminSidebarOpen }}>
      {children}
    </AdminSidebarContext.Provider>
  )
}

export const useAdminSidebar = () => {
  const context = useContext(AdminSidebarContext)
  if (context === undefined) {
    throw new Error('useAdminSidebar must be used within AdminSidebarProvider')
  }
  return context
}

